import axios from 'axios';
import { MDBFileUpload } from 'mdb-react-file-upload';
import {
  MDBBadge,
  MDBBtn,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBSelect,
  MDBSpinner
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Dropdown from "./../reusables/Dropdown"; // Adjust this path based on your file structure
import { getDomainsAndCategories } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
import { GeographyContext } from '../context/GeographyProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import { DomainContext } from '../context/DomainProvider';
import { CategoryContext } from '../context/CategoryContext';
const AddNewEntity = ({
  show,
  handleAddModalClose,
  setAddNewModalOpen,
  category,
  toggleAlertVisible,
  setAlertMessage,
  setAlertVisible,
  onDomainsUpdate,
  domain,  
  fetchItems
}) => {
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const {domainId,selectDomains,setDomainImages,setGroupedDomainsByDomain,setSelectDomains} = useContext(DomainContext);
  const {setGroupedCategoriesByDomain,setCategoryImages,selectCategories, setSelectCategories} = useContext(CategoryContext);
const {currencies,currencyOptions,location,ipAddress,setCountry} = useContext(GeographyContext);
const {tokenLoaded} = useContext(UserProfileContext);
  
  const {business, isPricing,setBusiness} = useContext(NavbarContext);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsData, setItemsData] = useState([
    { image: [], name: '', color: '', subdomain: [], categories: category ? [category] : [], price: 0.0, discountedPrice: 0.0, currency: '', buttonColor: '', country: '', descriptions: [], features: [] }
  ]);

  const handleAddFields = () => {
    setItemsData([...itemsData, { images: '', name: '', color: '', subdomain: [], categories: [], price: 0.0, discountedPrice: 0.0, currency: '', buttonColor: '', country: '', descriptions: [], features: [] }]);
  };
  const handleSelectCategoryChange = (index, selected) => {
    console.log("Selected Categories:", selected); // Debugging line
    setItemsData(prevItemsData => {
      const updatedItemsData = [...prevItemsData];
      updatedItemsData[index].categories = selected;
      return updatedItemsData;
    });
  };



  const handleSelectDomainChange = (index, selected) => {
     setItemsData(prevItemsData => {
      const updatedItemsData = [...prevItemsData];     
      updatedItemsData[index].domainIds = selected;   
      return updatedItemsData;
    });

  };
 



  useEffect(() => {
    
    if(selectDomains?.length === 0){
      setIsLoading(true)
    getDomainsAndCategories(domainId,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages);
    setIsLoading(false);
    }
  }, [domainId,  tokenLoaded,  setSelectCategories, setSelectDomains,  setCategoryImages, setDomainImages]);

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...itemsData];
    list[index][name] = value;
    setItemsData(list);
  };

  const [files, setFiles] = useState([]);

  // const handleFilesChange = (e) => {
  //   if (e.target?.files) {
  //     const newFiles = [...files, ...e.target.files];
  //     setFiles(newFiles);
  //   }
  // };
  
  const handleFilesChange = (e) => {
    if (files && files.length > 0) {
      const newFiles = [...files, ...e];
      setFiles(newFiles);
    } else {
      setFiles([...e]);
    }
  };

  const handleSave = async () => {
    setIsLoading(true);
  
    let latLngQuery = "";
    if (location) {
      console.log(`Latitude: ${location.latitude}, Longitude: ${location.longitude}`);
      latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
    } else {
      latLngQuery = `?ipAddress=${ipAddress}`;
    }
  
    try {
      const formData = new FormData();
  
      // Construct entity data
      const entities = itemsData.map((item) => ({
        firmId: localStorage.getItem('FIRM'),
        name: item.name,
        color: item.color,
        categoryIds: category ? [selectCategories.find(cat => cat.text === category)?.value] : item.categories,
        domainIds: item.domainIds,
        originalPrice: item.price,
        discountedPrice: item.discountedPrice,
        buttonColor: item.buttonColor,
        descriptions: item.descriptions,
        features: item.features,
        country: item.country
      }));
  
      // Append the entity to the formData
      formData.append('entity', new Blob([JSON.stringify({ entities })], { type: 'application/json' }));
  
      // Append the files to the formData
      files.forEach((file, index) => {
        formData.append(`images`, file); // Assuming multiple images are uploaded, adjust key as needed
      });
  
      // Configure API endpoint and method
      let endpoint = `${baseUrl}/entities/isolated/multiple`;
      endpoint = endpoint + latLngQuery;
  
      // Make API call with multipart/form-data
      const response = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true, // If your API requires cookies or session data
      });
  
      // Handle the API response
      if (response.status === 200 || response.status === 201) {
        fetchItems && fetchItems();
        onDomainsUpdate && onDomainsUpdate(domain, response.data, null, null, false);
        setAlertMessage('Item(s) added successfully');
        setAddNewModalOpen(false);
      } else if (response.status === 409) {
        setAlertMessage('Duplicate Items');
      } else {
        throw new Error('Error updating inventory');
      }
  
      // Close the modal
      handleAddModalClose();
    } catch (error) {
      console.error(error);
      setAlertMessage('Error updating inventory');
    } finally {
      setAlertVisible(true);
      setIsLoading(false);
    }
  };
  


  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  useEffect(() => {
    setIsUploadDisabled(!files || files.length === 0);
  }, [files]);

  const handleRemoveFields = (indexToRemove) => {
    // Remove the item at indexToRemove
    setItemsData(itemsData.filter((_, index) => index !== indexToRemove));
  };


  const handleDescriptionChange = (itemIndex, descIndex, event) => {
    const newItemsData = [...itemsData];
    newItemsData[itemIndex].descriptions[descIndex] = event.target.value;
    setItemsData(newItemsData);
  };
  const handleFeatureChange = (itemIndex, featureIndex, property, value) => {
    const newItemsData = [...itemsData];
    if (newItemsData[itemIndex].features) {
      newItemsData[itemIndex].features[featureIndex][property] = value;
      setItemsData(newItemsData);
    }
  };


  const handleAddDescription = (itemIndex) => {
    const newItemsData = [...itemsData];
    if (!newItemsData[itemIndex].descriptions) {
      newItemsData[itemIndex].descriptions = [];
    }
    newItemsData[itemIndex].descriptions.push('');
    setItemsData(newItemsData);
  };
  const handleRemoveDescription = (itemIndex, descIndex) => {
    const newItemsData = [...itemsData]; // Shallow copy of your itemsData
    if (newItemsData[itemIndex].descriptions) {
      newItemsData[itemIndex].descriptions.splice(descIndex, 1); // Remove the item at descIndex
    }
    setItemsData(newItemsData); // Update your state
  };


  const handleAddFeature = (itemIndex) => {
    const newItemsData = [...itemsData];

    // Check if 'features' array exists, if not, create it
    if (!newItemsData[itemIndex].features) {
      newItemsData[itemIndex].features = [];
    }

    // Add a new feature object to the 'features' array
    newItemsData[itemIndex].features.push({
      textValue: '', // Set default values for textValue, textColor, and icon
      textColor: 'black',
      icon: 'check'
    });

    setItemsData(newItemsData);
  };

  const handleRemoveFeature = (itemIndex, featureIndex) => {
    const newItemsData = [...itemsData]; // Shallow copy of your itemsData
    if (newItemsData[itemIndex].features) {
      newItemsData[itemIndex].features.splice(featureIndex, 1); // Remove the feature at featureIndex
      setItemsData(newItemsData); // Update your state
    }
  };




  const handleSelectChange = (index, name, selectedValue) => {
    console.log(selectedValue);  // Log the value to check its structure

    // If the name is 'Currency', then find the corresponding currency object
    if (name === "Currency") {
      const selectedCurrency = currencies.find(currency =>
        `${currency.country} (${currency.symbol})` === selectedValue.text
      );

      if (selectedCurrency) {
        const list = [...itemsData];
        list[index].currency = selectedCurrency.currencyName;
        list[index].country = selectedCurrency.country;
        // You can also set other properties like symbol, unit if needed...
        setItemsData(list);
      }
    } else {
      // Handle other select changes as before
      const list = [...itemsData];
      list[index][name] = selectedValue.text; // Assuming selectedValue is an object with a text property
      setItemsData(list);
    }
  };
  const   allFieldsFilled = itemsData.every(item => 
    item.name && item.domainIds?.length > 0 && item.categories?.length > 0
  );


  return (


    <MDBContainer >

      <MDBModal centered={true} open={show} onClose={()=>
        setAddNewModalOpen(false)} staticBackdrop={true} >
        <MDBModalDialog centered={true} size="lg">
          <MDBModalContent >
            <MDBModalHeader toggle={handleAddModalClose}>Add New Items</MDBModalHeader>
            {itemsData.map((itemData, index) => (


              <MDBModalBody key={index} style={{ borderRadius: "12px" }}>
                <div key={index} className='position-relative  text-black rounded-5'>

                  <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2 '>
                    <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => handleRemoveFields(index)} >
                      <MDBIcon fas icon="trash-alt" />
                    </MDBBtn>
                  </MDBBadge>
                  <MDBInput
                    label="Name *"
                    name="name"
                    value={itemData.name || ''}
                    onChange={(e) => handleInputChange(index, e)}
                  />


                  {isLoading ? (
                    <div className='d-flex justify-content-center align-items-center mt-2' >
                      <MDBSpinner color='danger'>
                        <span className='visually-hidden'>Loading...</span>
                      </MDBSpinner>
                    </div>
                  ) : (
                    <>
                      {category ?
                        <MDBInput label='Category *' name='categories' value={category} onChange={(e) => handleInputChange(index, e)} className='mt-2 ms-2' />
                        :
                        // <Dropdown label="Category *" name="categories" dataForDropDown={selectCategories}  onValueChange={handleSelectChange} />
                        <Dropdown label="Category *" name="categories" defaultValue={itemsData[index].length>0 ? itemsData[index].categories[0] : ''} dataForDropDown={selectCategories} onValueChange={(selected) => handleSelectCategoryChange(index, selected)} />

                      }
                      {/* <Dropdown label="Domain *" name="subdomain" dataForDropDown={selectDomains}  onValueChange={handleSelectChange}/> */}
                      <Dropdown label="Domain *" name="subdomain" defaultValue={itemsData[index].length>0 ? itemsData[index]?.domainIds[0] : ''} dataForDropDown={selectDomains} onValueChange={(selected) => handleSelectDomainChange(index, selected)} />

                      {(business === 'B2C' || business === 'SaaS' || isPricing) &&
                        <>  <MDBInput label='Price' id='typeNumber' name='price' type='number' className='mt-2' value={itemData.price} onChange={(e) => handleInputChange(index, e)} />
                          <MDBInput label='DiscountedPrice' name='discountedPrice' id='typeNumber' type='number' className='mt-2' value={itemData.discountedPrice} onChange={(e) => handleInputChange(index, e)} />

                          <MDBSelect
                            name='Currency'
                            label='Currency'
                            id='currency'
                            type='text'
                            className='mt-2'
                            data={currencyOptions}
                            visibleOptions={5}
                            onValueChange={(selectedValue) => handleSelectChange(index, "Currency", selectedValue)}
                          />
                        </>
                      }
                      <MDBInput className='mt-2'
                        label="ButtonColor"
                        name="buttonColor"
                        value={itemData.buttonColor || ''}
                        onChange={(e) => handleInputChange(index, e)}
                      />


                      {
                        itemData.descriptions?.map((description, descIndex) => (

                          <div key={descIndex} className='position-relative text-black rounded-5 bg-secondary p-2 text-dark bg-opacity-10 mt-2'>


                            <MDBInput
                              label={`description ${descIndex + 1}`}
                              id={`form${descIndex + 1}`}
                              type='text'
                              value={description || ''}
                              style={{ marginTop: '12px' }}
                              onChange={(e) => handleDescriptionChange(index, descIndex, e)}
                            />
                            <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2'>
                              <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => handleRemoveDescription(index)} >
                                <MDBIcon fas icon="trash-alt" />
                              </MDBBtn>
                            </MDBBadge>

                          </div>
                        ))
                      }
                      {
                        itemData.features?.map((feature, featureIndex) => (
                          <div key={featureIndex} className='position-relative text-black rounded-5 bg-success p-2 text-dark bg-opacity-10 mt-2' >
                            <h3 className='text-primary'>{`feature:${featureIndex + 1}`}</h3>
                            <MDBInput
                              label='textValue'
                              id={`form${featureIndex + 1}`}
                              type='text'
                              value={feature.textValue || ''}
                              style={{ marginTop: '12px' }}
                              onChange={(e) => handleFeatureChange(index, featureIndex, 'textValue', e.target.value)} // Pass property and value
                            />
                            <MDBInput
                              label='textColor'
                              id={`form${featureIndex + 1}`}
                              type='text'
                              value={feature.textColor || ''}
                              style={{ marginTop: '12px' }}
                              onChange={(e) => handleFeatureChange(index, featureIndex, 'textColor', e.target.value)} // Pass property and value
                            />
                            {/* Edit icon property */}
                            <MDBInput
                              label='icon'
                              id={`form${featureIndex + 1}`}
                              type='text'
                              value={feature.icon || ''}
                              style={{ marginTop: '12px' }}
                              onChange={(e) => handleFeatureChange(index, featureIndex, 'icon', e.target.value)} // Pass property and value
                            />

                            {/* Remove feature button */}
                            <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2'>
                              <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => handleRemoveFeature(index, featureIndex)}>
                                <MDBIcon fas icon="trash-alt" />
                              </MDBBtn>
                            </MDBBadge>
                          </div>
                        ))
                      }


                      <div className='d-flex justify-content-center align-items-center' >
                        <MDBBtn className='mt-2 me-2' size="sm" color="primary" onClick={() => handleAddDescription(index)}>
                          Add Descriptions
                        </MDBBtn>
                        <MDBBtn className='mt-2 ' size="sm" color="primary" onClick={() => handleAddFeature(index)}>
                          Add Feature
                        </MDBBtn>
                      </div>
                    </>
                  )}
                  <div className='d-flex justify-content-center align-items-center mt-2' >
                    {/* <MDBFileUpload multiple maxFileSize='2M' onChange={handleFilesChange} disabled={isUploadDisabled} /> */}
                    <MDBFileUpload className="mb-2 mt-2 justify-content-sm-around text-center" defaultMessage='' onChange={handleFilesChange} disabled={isUploadDisabled}/>
                  </div>
                </div>

              </MDBModalBody>

            ))}

            <MDBModalFooter>
              <MDBBtn
                size="sm"
                color={category ? 'primary' : 'dark'}
                onClick={handleAddFields}
              >Add More
              </MDBBtn>

              <MDBBtn
                size="sm"
                color={category ? 'primary' : 'success'}
                onClick={handleSave}
                disabled={!allFieldsFilled} 
              > Save
              </MDBBtn>
              <MDBBtn
                size="sm"
                color={category ? 'secondary' : 'link'}
                onClick={()=>
                  setAddNewModalOpen(false)}
              >x
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>


  );
};

AddNewEntity.propTypes = {
  show: PropTypes.bool.isRequired,
  handleAddModalClose: PropTypes.func.isRequired,
  category: PropTypes.string,
  toggleAlertVisible: PropTypes.func,
  setAlertMessage: PropTypes.func,
  setAlertVisible: PropTypes.func,
  onDomainsUpdate: PropTypes.func,
  domain: PropTypes.object,
  fetchItems: PropTypes.func,
  setAddNewModalOpen: PropTypes.func,
};

export default AddNewEntity;
